export const environment = {
  name: 'AdminPro',
  production: false,
  backend: 'https://martinbobbio-hospitals.herokuapp.com',
  googleId: '507173521202-8j409puqm403avu6mkris8fb016s2tvl.apps.googleusercontent.com'
};



// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/environments/environment.ts